import { useEffect, useState } from "react";

const TypewriterHeading = ({ text }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[index]);
        setIndex((prev) => prev + 1);
      }, 55);
      return () => clearTimeout(timeout);
    } else {
      setDone(true);
    }
  }, [index, text]);

  return (
    <div className="flex items-center gap-3 mb-5">
      <h2 className="text-sm md:text-base font-mono tracking-[0.2em] text-slate-200/90">
        <span className="text-cyan-500/50 mr-1">&gt;</span>
        <span>{displayedText}</span>
        {!done && (
          <span className="cursor-blink ml-0.5 text-emerald-400">▊</span>
        )}
      </h2>
      {done && (
        <div
          className="flex-1 h-px"
          style={{
            background:
              "linear-gradient(90deg, rgba(0,255,153,0.3), transparent)",
          }}
        />
      )}
    </div>
  );
};

export default TypewriterHeading;
